"use client";

import { useEffect } from "react";

/**
 * Submits the form with the given id once, on mount.
 *
 * In SSO mode the only thing the login page can do is send the person to the
 * identity provider, so it does that without waiting for a click. The form and
 * its button stay on the page as the fallback if the submit is blocked.
 */
export function AutoSubmit({ formId }: { formId: string }) {
  useEffect(() => {
    const form = document.getElementById(formId);
    if (form instanceof HTMLFormElement) form.requestSubmit();
  }, [formId]);

  return null;
}
